import { FC } from "react";
import { Box } from "@material-ui/core";

import { LabelField } from "components";
import {
  formatMarketplaceMedian,
  formatMarketplaceMedianAmountSource,
  formatNumber,
} from "lib/format";
import { BaseAmountSource } from "services/listings/types";

export interface MarketplaceMedianLabelFieldProps {
  marketplaceMedian: string | null;
  marketplaceMedianMultiplier: number;
  marketplaceMedianSource: BaseAmountSource;
}

const MarketplaceMedianLabelField: FC<MarketplaceMedianLabelFieldProps> = ({
  marketplaceMedian,
  marketplaceMedianMultiplier,
  marketplaceMedianSource,
}) => {
  return (
    <LabelField
      label="Marketplace Median"
      value={formatMarketplaceMedian(marketplaceMedian)}
      tooltipText={
        <Box>
          The Marketplace Median price is based on the median sale price of
          other catalogs within a similar Dollar Age range.
        </Box>
      }
      helperText={`${formatNumber(marketplaceMedianMultiplier)} x
    ${formatMarketplaceMedianAmountSource(marketplaceMedianSource)}`}
    />
  );
};

export default MarketplaceMedianLabelField;
